"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _FlexRow = require("../../../../components/layout/flex/FlexRow");
var _Icon = require("../../../../components/media/icon/Icon");
var _Subheading = _interopRequireDefault(require("../../../../components/text/Subheading"));
var _i18n = require("@react-aria/i18n");
var _InnerButton = require("../../buttons/InnerButton");
var _Calendar = require("./Calendar.styled");
var _jsxRuntime = require("react/jsx-runtime");
function getShowBackButtons(prevButtonProps, prevYearButtonProps) {
  return prevButtonProps || prevYearButtonProps;
}
function getShowForwardButtons(nextButtonProps, nextYearButtonProps) {
  return nextButtonProps || nextYearButtonProps;
}
var CalendarHeader = function CalendarHeader(_ref) {
  var dateInMonth = _ref.dateInMonth,
    prevButtonProps = _ref.prevButtonProps,
    nextButtonProps = _ref.nextButtonProps,
    nextYearButtonProps = _ref.nextYearButtonProps,
    prevYearButtonProps = _ref.prevYearButtonProps,
    timeZone = _ref.timeZone;
  var monthDateFormatter = (0, _i18n.useDateFormatter)({
    month: 'long',
    year: 'numeric',
    timeZone: timeZone
  });
  var firstMonthTitle = monthDateFormatter.format(dateInMonth);
  var showBackButtons = getShowBackButtons(prevButtonProps, prevYearButtonProps);
  var showForwardButtons = getShowForwardButtons(nextButtonProps, nextYearButtonProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
    gap: 'none',
    justifyContent: showBackButtons ? 'flex-start' : 'flex-end',
    children: [prevYearButtonProps ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.CalendarHeaderCellWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.InnerButton, _objectSpread({}, prevYearButtonProps, {
        "data-cy": 'prev-year-button',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: 'rewind'
        })
      }))
    }) : null, prevButtonProps ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.CalendarHeaderCellWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.InnerButton, _objectSpread({}, prevButtonProps, {
        "data-cy": 'prev-month-button',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: 'chevronLeft'
        })
      }))
    }) : null, !showBackButtons ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.CalendarHeaderCellPadding, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexRow.FlexRow, {
      justifyContent: 'center',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Subheading.default, {
        children: firstMonthTitle
      })
    }), !showForwardButtons ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.CalendarHeaderCellPadding, {}) : null, nextButtonProps ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.CalendarHeaderCellWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.InnerButton, _objectSpread({}, nextButtonProps, {
        "data-cy": 'next-month-button',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: 'chevronRight'
        })
      }))
    }) : null, nextYearButtonProps ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.CalendarHeaderCellWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.InnerButton, _objectSpread({}, nextYearButtonProps, {
        "data-cy": 'next-year-button',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: 'fastforward'
        })
      }))
    }) : null]
  });
};
exports.CalendarHeader = CalendarHeader;